import React from "react";
import { Text, View } from "@/styles/reactnative";

interface Iprops {
  title?: string;
}
const MarketTableTopHeaderTitle = ({ title }: Iprops) => {
  return (
    <View style={{ alignItems: "flex-start", paddingBottom: 10 }}>
      <Text size={16} style={{ fontWeight: "600" }}>
        {title}
      </Text>
    </View>
  );
};

export default React.memo(MarketTableTopHeaderTitle);
